import * as React from "react";
import { Input as SharedInput } from "@finitless/shared/components/Input";

export interface InputProps extends Omit<
  React.ComponentProps<"input">,
  "size"
> {
  description?: React.ReactNode;
  error?: React.ReactNode;
  label?: React.ReactNode;
  variant?: "default" | "dark" | "light";
  size?: "sm" | "md" | "lg";
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  containerClassName?: string;
  labelClassName?: string;
  labelStyle?: React.CSSProperties;
}

/**
 * Compatibility adapter owner: @finitless/shared/components/Input.
 * Consumers: the dashboard UI barrel and existing dashboard Input imports.
 * Retire after those imports point at the shared owner and a zero-consumer search passes.
 * @deprecated Import Input from @finitless/shared/components/Input for new consumers.
 */
const Input = SharedInput as React.ForwardRefExoticComponent<
  InputProps & React.RefAttributes<HTMLInputElement>
>;

export { Input };
